var _path, _path2, _rect, _rect2, _path3, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtPhoneNumerUnregistered = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 120,
  x: 119,
  y: 37.155,
  fill: "#3863F0",
  rx: 12,
  transform: "rotate(-10 119 37.155)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 112,
  x: 123.634,
  y: 40.4,
  fill: "#fff",
  rx: 8,
  transform: "rotate(-10 123.634 40.4)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  fillRule: "evenodd",
  d: "M171.98 73.453a3.511 3.511 0 0 0-4.891.861l-.001.002-4.871 6.94-6.956-4.87a3.51 3.51 0 0 0-4.892.862 3.511 3.511 0 0 0 .863 4.892l6.955 4.87-4.87 6.954a3.51 3.51 0 0 0 .863 4.892 3.51 3.51 0 0 0 4.891-.863l4.87-6.954 6.954 4.87a3.51 3.51 0 0 0 4.892-.863 3.51 3.51 0 0 0-.862-4.892l-6.955-4.87 4.87-6.954a3.52 3.52 0 0 0-.86-4.877Zm-2.371 1.407a1.51 1.51 0 0 0-.883.603l-6.019 8.578 6.02-8.578c.22-.315.537-.52.882-.603Zm3.657 19.642a1.508 1.508 0 0 1-1.223-.232l-8.593-6.017 8.593 6.017c.37.26.816.33 1.223.232Zm-16.716 2.947a1.512 1.512 0 0 1-1.595-2.338l6.017-8.593-8.593-6.016 8.593 6.017-6.017 8.592a1.51 1.51 0 0 0 .372 2.107c.37.26.816.33 1.223.231Z",
  clipRule: "evenodd"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 4,
  x: 166.487,
  y: 139.464,
  fill: "#3863F0",
  rx: 2,
  transform: "rotate(-10 166.487 139.464)"
})));
export default SvgArtPhoneNumerUnregistered;